import { useContext, useMemo } from "react";
import { UnidentifiedCreationInfo } from "../../../generated/data-contracts";
import { ILinkValue } from "../../../models";
import {
  AuthorsUrls,
  AuthorsUtils,
  IAxiosError,
  TableUtils,
} from "../../../utils";
import { AvisSection } from "../../shared/components/form";
import { AvisSimpleTable, IColumnConfig } from "../../shared/components/table";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";

interface IUnidentifiedCreationListGridProps {
  initData?: UnidentifiedCreationInfo[];
  loading: boolean;
  error?: IAxiosError;
}

export function UnidentifiedCreationListGrid(
  props: Readonly<IUnidentifiedCreationListGridProps>,
) {
  const { initData, loading, error } = props;
  const { res, ctxRightsHolder } = useContext(AvisContext);

  const columnMetadata: IColumnConfig[] = useMemo(
    () => [
      TableUtils.columnConfigNested<UnidentifiedCreationInfo>(
        "creationClass",
        "name",
        res("label_CreationClassName"),
        150,
      ),
      TableUtils.columnConfigLink<UnidentifiedCreationInfo>(
        "creationName",
        res("label_CreationName"),
        (rowData) => {
          return {
            title: rowData.creationName,
            url: AuthorsUtils.getUrlWithParams(
              AuthorsUrls.rightsHoldersCreationUnidentifiedView,
              {
                rightsHolderId: ctxRightsHolder?.rightsHolderId,
                rightsHolderTypeCode: ctxRightsHolder?.rightsHolderTypeCode,
                unidentifiedCreationProcessId:
                  rowData.unidentifiedCreationProcessId,
              },
            ),
          } as ILinkValue;
        },
      ),
    ],
    [res, ctxRightsHolder],
  );

  return (
    <AvisSection>
      <ErrorLoadingDataHoc error={error} loading={loading}>
        <AvisSimpleTable<UnidentifiedCreationInfo>
          columnMetadata={columnMetadata}
          data={initData}
          mobileCellsVisible={4}
          columnWidths={[20, 80]}
        />
      </ErrorLoadingDataHoc>
    </AvisSection>
  );
}
